var map = {
	"./beauty_lifestyle_on.png": 64013,
	"./bread_dessert_on.png": 48252,
	"./casual_resto_on.png": 80181,
	"./digital_appliance_on.png": 59058,
	"./drugstore_wellness_on.png": 53392,
	"./ewallet_shopping_on.png": 60583,
	"./food_delivery_on.png": 66001,
	"./groceries_shop_on.png": 96820,
	"./homeKids.png": 50923,
	"./home_kids_on.png": 28242,
	"./transpo_travel_on.png": 5699
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86044;